import { Provider } from './provider.model';
import { User } from './user.model';
import { Real } from './real.model';

export class ProviderUser {

  public id: string;
  public promotionsViaEmail: boolean;
  public promotionsViaSms: boolean;
  public notificationsViaEmail: boolean;
  public notificationsViaSms: boolean;
  public position: number;
  public user: User;
  public editorOnlyAtLocation: Real;
  public provider: Provider;
  public onBehalfOfBooker: boolean;

  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id || null;
    this.position = obj && obj.position || null;
    this.promotionsViaEmail = obj && obj.promotionsViaEmail || false;
    this.promotionsViaSms = obj && obj.promotionsViaSms || false;
    this.notificationsViaEmail = obj && obj.notificationsViaEmail || false;
    this.notificationsViaSms = obj && obj.notificationsViaSms || false;
    this.onBehalfOfBooker = obj && obj.onBehalfOfBooker || false;


    if ( obj && obj.provider ) {
      this.provider = ( obj.provider instanceof Provider ) ? obj.provider: new Provider( obj.provider );
    }

    if ( obj && obj.user ) {
      this.user = ( obj.user instanceof User ) ? obj.user: new User( obj.user );
    }

    if ( obj && obj.editorOnlyAtLocation ) {
      this.editorOnlyAtLocation = ( obj.editorOnlyAtLocation instanceof Real ) ? obj.editorOnlyAtLocation: new Real( obj.editorOnlyAtLocation );
    }

  }

}  